import { render, staticRenderFns } from "./RELPlotagem.vue?vue&type=template&id=a6d43f54&"
import script from "./RELPlotagem.vue?vue&type=script&lang=js&"
export * from "./RELPlotagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports